import { Text, Badge, Box } from '@chakra-ui/react';
import DataTableCard from './DataTableCard';
import { useBinderCardColors } from '../hooks/useBinderCardColors';
import { formatSimpleValue } from '../utils/fieldFormatting';
import ValidationBadge from './ValidationBadge';

interface ModifiedCustomizedCardProps {
  data?: any;
}

const ModifiedCustomizedCard = ({ data }: ModifiedCustomizedCardProps) => {
  const colors = useBinderCardColors();

  const formatModifiedCustomizedStatus = (hasModifiedCustomized: any) => {
    return (
      <Badge colorScheme="blue" variant="outline" fontSize="xs">
        {hasModifiedCustomized ? 'Yes' : 'No'}
      </Badge>
    );
  };

  // Create table rows from processed vehicle data
  const vehicleRows =
    data?.vehicles?.map((vehicle: any) => {
      return [
        vehicle.name,
        formatModifiedCustomizedStatus(vehicle.hasModifiedCustomized),
        vehicle.remarks ? (
          <Text fontSize="sm">{formatSimpleValue(vehicle.remarks)}</Text>
        ) : (
          <Text color="gray.400" fontStyle="italic" fontSize="sm">
            No remarks
          </Text>
        ),
        <ValidationBadge status={vehicle.isValid ? 'pass' : 'caution'} />,
      ];
    }) || [];

  const headers = ['Vehicle', 'Modified/Customized', 'Remarks', 'Outcome'];

  // Handle empty state
  if (vehicleRows.length === 0) {
    return (
      <Box p={4} borderRadius="md" bg={colors.emptyFieldBgColor}>
        <Text color="gray.500" fontStyle="italic" textAlign="center">
          No vehicle data available
        </Text>
      </Box>
    );
  }

  return (
    <DataTableCard
      description="Have any vehicles on the application been modified or customized?"
      headers={headers}
      rows={vehicleRows}
    />
  );
};

export default ModifiedCustomizedCard;
